// Image imports
import kutzFamilyPhoto from '../../../images/kutz_family_photo.webp';

export const kutzFamilyMemorial = {
  id: 7,
  name: 'The Kutz Family',
  category: 'families',
  images: {
    family: kutzFamilyPhoto
  },
  info: `

"Instead of holding a kite festival for peace, the Kutz family were slaughtered in cold blood." - VINnews

![Kutz Family](${kutzFamilyPhoto})
*The Kutz family: Aviv, Livnat, Rotem, Yonatan, and Yiftach*

## A Family of Peace and Hope

The Kutz family, residents of Kibbutz Kfar Aza near the Gaza border, were known for their commitment to peace and community. They consisted of:

- Aviv Kutz (54)
- Livnat Kutz (49)
- Rotem (19)
- Yonatan (17)
- Yiftach (15)

## The Tragic Day

On October 7, 2023, instead of celebrating Simchat Torah and holding their annual kite festival for peace, the entire Kutz family was murdered by Hamas terrorists in their home.

## Lives Full of Promise

### Aviv Kutz
- Deputy director of a consulting firm
- Engaged in agricultural work
- Created spectacular welded sculptures
- Founder of the annual "Kibutionade" kite festival for peace

### Livnat Kutz
- Graphic designer
- Founder of "Workshop", an educational initiative integrating ancient handcrafts into school curriculums
- Known for her intuitive ability to sense and meet the needs of those around her

### Rotem Kutz
- Served as a rookie commander at a training base
- Cared for toddlers and children in Kfar Aza education
- Talented in sewing and baking

### Yonatan Kutz
- Outstanding basketball player in Hapoel Tel Aviv's youth team
- Studied at the Green Village Boarding School
- Known for his sensitivity and infectious laughter

### Yiftach Kutz
- Aspiring basketball player, following in his brother's footsteps
- Known for his constant smile and ability to create joy around him

## A Legacy of Peace

The Kutz family was deeply committed to peace and coexistence. Aviv's annual kite festival, scheduled for October 7, was a symbol of their hope for a better future. Livnat's "Workshop" program provided a space for creativity and healing in areas affected by conflict.

## The Last Message

On that fateful Saturday, at 2:45 PM, Livnat sent a message to friends, saying, "Hi guys, we got into the shelter in our house, we're all doing okay." Tragically, this was the last communication from the family.

## Remembering the Kutz Family

The family was found embracing each other, a final act of love in the face of unimaginable horror. Their loss has left a deep void in their community and in the hearts of all who knew them.

Ziv, Livnat's brother, lamented at their funeral:

> "How can we bury five pure souls? Yiftach, what a strong child you were with such a gentle and beautiful soul. Yonatan, I always told you it's never too late to switch teams; now it's truly too late. Rotem, so beautiful and talented, always bringing light and laughter into the room. We were so proud of you when you completed your IDF Intelligence Corps course. Aviv, you were like a brother, a role model, a true father."

The Kutz family's story is a stark reminder of the human cost of conflict and the importance of continuing to work towards peace, even in the darkest of times.

May the memory of Aviv, Livnat, Rotem, Yonatan, and Yiftach be a blessing and an inspiration for peace.

[Read more about the Kutz family](https://www.timesofisrael.com/kutz-family-father-mother-and-three-teens-die-in-embrace/)

[Learn about Livnat's Wings, a project in memory of Livnat Kutz](https://www.livnatswings.org/en/%D7%94%D7%A1%D7%99%D7%A4%D7%95%D7%A8-%D7%A9%D7%9C-%D7%9C%D7%99%D7%91%D7%A0%D7%AA)

`
};